import ApiService from "./api.service";

const Employees = {
  avaibleRole: [{
      value: "admin",
      text: "Administrator"
    },
    {
      value: "manager",
      text: "Kierownik"
    },
    {
      value: "employee",
      text: "Pracownik"
    }
    ,
    {
      value: "employee_simple",
      text: "Pracownik (ograniczony dostęp)"
    }
  ],
  create: async function (data) {
    let response = await ApiService.post("/employee", data, "User was created");
    return response.data;
  },
  update: async function (user_id, data) {
    let response = await ApiService.put("/employee/" + user_id, data, "User profile was updated");
    return response.data;
  },
  delete: async function (user_id) {
    await ApiService.delete("/employee/" + user_id, {}, "User was deleted");
    return true;
  },
  search: async function (search) {
    let query = (search) ? {
      q: search
    } : {};
    let response = await ApiService.get("/employees", query);
    return response.data.employees;
  }
};

export default Employees;